import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { ShipmentTaskModel } from '../../models/shipment-task.model';
import { DeliveryTypeIconComponent } from '../../../_components/delivery-type-icon/delivery-type-icon.component';

@Component({
  selector: 'shipment-box',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatMenuModule, MatIconModule, DeliveryTypeIconComponent],
  templateUrl: './shipment-box.component.html',
  styleUrl: './shipment-box.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShipmentBoxComponent {
  @Input() shipmentTask!: ShipmentTaskModel;

  @Output() markAsCompleted = new EventEmitter<ShipmentTaskModel>();
  @Output() undoCompletion = new EventEmitter<ShipmentTaskModel>();
}
